import React from 'react';

import { useLocale } from '../../hooks/use-locale';

interface Props {
  message?: string;
}

const ScreenReaderMessage = ({ message }: Props) => {
  const { Message } = useLocale();

  return (
    <span className="screen-reader-only">
      {message ?? Message.OPEN_IN_NEW_TAB}
    </span>
  );
};

export default ScreenReaderMessage;
